import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import footer_logo from '../Assets/logo.png';


const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer-container container'>
        <div className="footer-main">
          <div className="footer-about">
            <Link to='/' className="footer-logo">
              <img src={footer_logo} alt="Madurai Special Logo" />
              <p>MADURAI SPECIAL</p>
            </Link>
            <p className="footer-tagline">Authentic flavors, delivered to your doorstep.</p>
          </div>

          <div className="footer-links-section">
            <h4>Legal</h4>
            <ul className="footer-links">
              <li><Link to="/terms">Terms & Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/returns">Return Policy</Link></li>
              <li><Link to="/shipping">Shipping Policy</Link></li>
              <li><Link to="/ContactUs">Contact Us</Link></li>
            </ul>
          </div>

          {/* --- The "Follow Us" section has been REMOVED --- */}

        </div>
        <div className="footer-bottom">
          <hr />
          <p>Created by <a href="https://agency.riny.in/fazil" target="_blank" rel="noopener noreferrer">MOHMED FAZIL</a></p>
          <p className="footer-copyright">Copyright @ {new Date().getFullYear()} - All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;